import { render, staticRenderFns } from "./catalogueItemDetail.vue?vue&type=template&id=d343f734&scoped=true"
import script from "./catalogueItemDetail.vue?vue&type=script&lang=js"
export * from "./catalogueItemDetail.vue?vue&type=script&lang=js"
import style0 from "./catalogueItemDetail.vue?vue&type=style&index=0&id=d343f734&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d343f734",
  null
  
)

export default component.exports